import React, { Component } from "react";
import "./index.scss";
import UserMessage from "./subview/UserMessage";
import UserMessageInfo from "./subview/UserMessageInfo";
import AiMessage from "./subview/AiMessage";
import WhatsApp from "./subview/whatsapp.js";
import GoodsMessage from "./subview/GoodsMessage";
import WebSocketClient from "../../utils/websocket";
import AudioRecorder from "./subview/AudioRecorder";
import ColorChangeButton from "./subview/ColorChangeButton";
import ConnectionLoading from "./subview/ConnectionLoading.js";
import { Picker, DatetimePicker, Skeleton, Radio, Toast, Popup, Button, Popover, Loading, Input } from 'react-vant';
import { FixedSizeList as List } from 'react-window';
import { Menu, Dropdown, DatePicker } from 'antd';
import '@vant/touch-emulator';

import LoadingMessage from "./subview/loadingMessage";
import StarDiskMessage from "./subview/StarDiskMessage";
import 'animate.css';
import PageTitle from "../../utils/pageTitle";
import ageUtils from '../../utils/ageUtils';
import { wsUrl, httpUrl } from '../../utils/apiService';
import PcGoodsMessage from "./subview/PcGoodsMessage";
import axios from 'axios';
import HeadTitle from "./subview/HeadTitle.js";
import { getStarSigns, getLocaleDescription, getPickerPhrases, getUserInfoLanguage, getSendUserInfoLanguage, getOtherConfig, getGenderLanguage, getSendEmail } from './subview/locale.js'
import dayjs from "dayjs";
import HelloMessage from "./subview/HelloMessage.js";
import DissMessage from "./subview/dissMessage.js";
import Asr from "./subview/asr/Asr.js";


let defaultImg = require("../../assets/update_new/ai_bot_avator.png");
let headTitleName = 'Sophia'

const sendBtnIng = require("../../assets/img/send_ing.png");
import sendBtnYes from '../../assets/update_new/send_button_yes.svg';
import sendBtnNo from '../../assets/update_new/send_button_no.svg';
const voice = require("../../assets/img/voice.png");
const floatingBtn = require("../../assets/img/scroll_down.png");
const zhanxingbackground = require("../../assets/update_new/astrolabe.png");
import arrow_left from '../../assets/update_new/arrow_left_white.svg';
import arrow_right from '../../assets/update_new/arrow_right_white.svg';
import buttonSign from '../../assets/update_new/hello_button_sign.svg';
import buttonSignYellow from '../../assets/update_new/button_sign_yellow.svg'
import starSignClose from '../../assets/update_new/star_sign_close.svg'

import aries from '../../assets/update_new/aries.svg'
import taurus from '../../assets/update_new/taurus.svg'
import gemini from '../../assets/update_new/gemini.svg'
import cancer from '../../assets/update_new/cancer.svg'
import leo from '../../assets/update_new/leo.svg'
import virgo from '../../assets/update_new/virgo.svg'
import libra from '../../assets/update_new/libra.svg'
import scorpio from '../../assets/update_new/scorpio.svg'
import sagittarius from '../../assets/update_new/sagittarius.svg'
import capricorn from '../../assets/update_new/capricorn.svg'
import aquarius from '../../assets/update_new/aquarius.svg'
import pisces from '../../assets/update_new/pisces.svg'
import sign_selected from '../../assets/update_new/choose_sign_in.svg'

const zodiacSigns = [
    { name: 'Taurus', image: taurus },
    { name: 'Aries', image: aries },
    { name: 'Gemini', image: gemini },
    { name: 'Libra', image: libra },
    { name: 'Leo', image: leo },
    { name: 'Virgo', image: virgo },
    { name: 'Cancer', image: cancer },
    { name: 'Scorpio', image: scorpio },
    { name: 'Capricorn', image: capricorn },
    { name: 'Aquarius', image: aquarius },
    { name: 'Pisces', image: pisces },
    { name: 'Sagittarius', image: sagittarius },
];
//等待第一句话loading 是否已经关闭
let connection_loading = false;
//消息文本内容
let newMessage = "";
//是否第一个end=false的文本
let count = 0;
let current_locale = '';
//当前语言
let language_type = [];
//picker 语言
let picker_language = [];
//是否可以触发发送按钮
let canSend = true;

//浏览器中是否有消息内容的缓存  true会接受招呼 false不会接受招呼
let first_message = true;

// 记录初始触摸点位置
let startY = 0;

// 设置一个超时，等待消息
const timeoutDuration = 1500;

//记录点击 用于过滤底部拦
let clickBottom = [];

//用于判断是从聊天内选择信息 还是 修改信息
let isChoose = false;

//用于判断当前点击等待的是那个条目的星盘信息
//测算内容共用
let starDiskIndex = 0;

let messageQueue = []; // 消息队列
let isProcessing = false; // 是否正在处理消息
const delay = 50; // 延迟处理时间，单位毫秒
let intervalId = null; // 定时器 ID

let audioQueue = []; // 音频消息队列
let isProcessingAudio = false; // 是否正在处理音频消息
let source = null; //音频源

let email_hash = '';//发送邮箱需要消息md5对应


const audioContext = new (window.AudioContext || window.webkitAudioContext)();

//录制出来的语音文本
let recordText = '';
//音频播放是否停止
let isStopAudio = false;

//音频播放队列是否处理完成标记
let isQueueEmptyAfterProcess = false;

let isFill_in = false; //是否正在填写信息阶段 用于是否可以在输入框发消息


const columns = [
    { text: 'Angela_Bassett', value: 'African_Americans_Angela_Bassett' },
    { text: 'Morgan_Freeman', value: 'African_Americans_Morgan_Freeman' },
    { text: 'sade_smooth', value: 'African_Americans_Femal_sade_smooth' },
    { text: 'Jennifer_Lawrence', value: 'North_America_Female_Jennifer_Lawrence_First_choice' },
    { text: 'Jennifer_Lopez', value: 'Hispanic_Jennifer_Lopez' },
    { text: 'James_Hong', value: 'Asia_Male_James_Hong' },
]

let roleDefault = columns[3].value
let psychic_id = '0'

let debounceStopAudio = Date.now();

const psychicData = [
    { psychic_id: '1', psychic_name: 'Mary', psychic_avatar: require('../../assets/pyschicImage/psychic_head_1.png'), psychic_img: require('../../assets/pyschicImage/psychic_img_1.png') },
    { psychic_id: '2', psychic_name: 'Selene', psychic_avatar: require('../../assets/pyschicImage/psychic_head_2.png'), psychic_img: require('../../assets/pyschicImage/psychic_img_2.png') },
    { psychic_id: '3', psychic_name: 'Aino', psychic_avatar: require('../../assets/pyschicImage/psychic_head_3.png'), psychic_img: require('../../assets/pyschicImage/psychic_img_3.png') },
    { psychic_id: '4', psychic_name: 'Sakura', psychic_avatar: require('../../assets/pyschicImage/psychic_head_4.png'), psychic_img: require('../../assets/pyschicImage/psychic_img_4.png') },
    { psychic_id: '5', psychic_name: 'Lia', psychic_avatar: require('../../assets/pyschicImage/psychic_head_5.png'), psychic_img: require('../../assets/pyschicImage/psychic_img_5.png') },
    { psychic_id: '6', psychic_name: 'Terra', psychic_avatar: require('../../assets/pyschicImage/psychic_head_6.png'), psychic_img: require('../../assets/pyschicImage/psychic_img_6.png') },
    { psychic_id: '7', psychic_name: 'Luna', psychic_avatar: require('../../assets/pyschicImage/psychic_head_7.png'), psychic_img: require('../../assets/pyschicImage/psychic_img_7.png') },
    { psychic_id: '8', psychic_name: 'Astra', psychic_avatar: require('../../assets/pyschicImage/psychic_head_8.png'), psychic_img: require('../../assets/pyschicImage/psychic_img_8.png') },
];

export default class Chat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //
            //是否显示填写信息表单
            showInfoFrom: false,
            //是否显示生日选择器
            showBirthdayPicker: false,
            //是否显示星座选择器
            showStarPicker: false,
            //新星座列表选中状态
            activeSign: '',
            //新生日选项的值
            newBirthday: new Date(1999, 0, 1),
            //是否显示新生日
            newBirthdayShow: false,
            //新性别
            newGender: 'Male',
            //新血型
            newBloodType: 'A',

            //消息列表
            messageList: [],
            //ws参数相关
            ws: null,
            sessionId: '',
            userId: '',
            userName: '',
            userAge: '',
            userGender: '',
            birthday: '',
            ad_sid: '',

            botName: 'ZodiacFortuneTeller',
            userAvatar: '',
            birthplace: '',
            skuId: ',,',
            motive: '',

            preferenceTags: '',

            //是否显示闪烁光标
            showCursor: false,
            showSend: true,
            //是否显示触底按钮
            isBottomVisible: false,
            //是否显示聊天loading
            isChatLoading: true,
            //pc端 商品
            product: [],
            FortuneTellerName: '',
            //是否显示用户 选择yes no
            isShowYesNo: false,

            //是否显示邮箱发送的弹窗
            sendEmailVisible: false,
            //是否显示发送成功的弹窗
            sendSuccessVisible: false,
            //邮箱
            email: '',
            //邮箱是否可以通过交验
            isValidEmail: true,
            //是否显示语音识别底部栏
            isShowVoice: false,
            //是否正在录音
            isRecording: false,
            //音量
            volume: 0,
            //静默时间导致停止通知语音控件复原
            vadEnd: false,
            //用于判断当前播放的是那个条目的语音
            playAudioIndex: -1,
            //用于判断是否为加载出来语音播放
            showAudioLoading: false,
            //用于判断是否显示招呼语内容,
            isHelloView: true,
            inputValue: '',
            tipsList: [],
            //是否显示商品详情
            isShowProduct: false,
            iframeSrc: '',

            //是否显示ASR页面
            isShowASR: false,
            vadDelay: 0,

            helloImage: '',//招呼页人物图片

            //出生地
            birthplacePop: false,
            countryList: [],
            country: '',
            cityList: [],
            cityData: {},
            city: '',
            lat: '',
            long: '',
            searchInputValue: '',
            searchData: [],
            showSearchData: false,
            //选择的属性
            isTab: '1',
            cityLoading: true,

            //是否显示跳转whatsapp 弹窗
            isShowWhatsApp: false,
        };
        this.reconnectAttempts = 0,//当前重连次数
            this.MAX_RECONNECT_ATTEMPTS = 5;//最大重连次数
        this.RECONNECT_INTERVAL = 5000;//重连时间

        //发送消息
        this.sendMessage = this.sendMessage.bind(this);
        //消息列表滚动
        this.messagesContainerRef = React.createRef();
        //输入框
        this.inputFieldRef = React.createRef();

        //语音播放角色切换
        this.roleRef = React.createRef();

        //底部联想词
        this.popoverRef = React.createRef();
        //流式内容输出次数，用于判断减少多次触发触底操作
        this.updateNum = 0;
        //记录入站时间
        this.startDialogTime = '';

        //出生地选择
        this.cityListRef = React.createRef();
        this.searchListRef = React.createRef();
        this.cityDebounceTimeout = null; // 定时器变量
    }

    //获取设备信息
    getDeviceAndBrowserInfo() {
        var userAgent = window.navigator.userAgent;
        var deviceType = "Unknown";
        var browserType = "Unknown";
        // 判断设备类型
        if (/mobile/i.test(userAgent)) {
            deviceType = "Mobile";
        } else if (/tablet/i.test(userAgent)) {
            deviceType = "Tablet";
        } else {
            deviceType = "Desktop";
        }

        // 判断浏览器类型
        if (/Chrome/.test(userAgent) && /Google Inc/.test(navigator.vendor)) {
            browserType = "Chrome";
        } else if (/Firefox/.test(userAgent)) {
            browserType = "Firefox";
        } else if (/Safari/.test(userAgent)) {
            browserType = "Safari";
        } else if (/Edge/.test(userAgent)) {
            browserType = "Edge";
        } else if (/MSIE/.test(userAgent) || /Trident/.test(userAgent)) {
            browserType = "Internet Explorer";
        }

        return {
            deviceType: deviceType,
            browserType: browserType
        };
    }
    // 获取 Cookie 值的辅助函数
    getCookie(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
    }
    // 设置 Cookie 值的辅助函数
    setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = "; expires=" + date.toUTCString();
        document.cookie = name + "=" + value + "; path=/" + expires;
    }

    // 生成复杂的用户 ID
    generateComplexUserId() {
        const timestamp = Date.now().toString(36); // 时间戳的36进制表示
        const randomNum = Math.random().toString(36).substr(2, 9); // 随机数
        const browserInfo = navigator.userAgent.replace(/\D+/g, '').substr(0, 10); // 截取部分浏览器信息
        return `user_${timestamp}_${randomNum}_${browserInfo}`;
    }

    // 创建或获取用户 ID
    getOrCreateUserId() {
        let userId = this.getCookie('userId');
        // 如果不存在则生成新的用户 ID
        if (!userId) {
            userId = this.generateComplexUserId();
            this.setCookie('userId', userId, 365); // 将用户 ID 存储到 Cookie 中
        }
        return userId;
    }

    //pc商品数据请求展示
    pcHttpSku = (content) => {
        if (content && content[0]) {
            axios({
                method: 'get',
                url: httpUrl + '/api/dtc_sku_list',
                params: {
                    "inventory_quantity": content[0].inventory_quantity,
                    "main_material": content[0].main_material,
                    "product_status": content[0].product_status,
                    "ethnicity": content[0].ethnicity,
                    "target_audience": content[0].target_audience,
                    "change_purpose": content[0].change_purpose,
                    "in_house_development": content[0].in_house_development,
                    "customizable": content[0].customizable,
                    "customizable_accessories": content[0].customizable_accessories,
                    "product_category": content[0].product_category,
                    "esoteric_tag": content[0].esoteric_tag,
                    "gender": this.state.newGender,
                    "constellation": this.state.activeSign,
                    "bot_name": this.state.botName,
                }
            })
                .then(response => {
                    this.setState({
                        product: response.data.data
                    })
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }
    handleUserId = (event) => {
        // 提取并设置 userId
        const sessionId = localStorage.getItem("sessionId") || '';
        const loaclMessageList = JSON.parse(localStorage.getItem("starmessageList")) || [];
        if (loaclMessageList.length > 0) {
            first_message = false;
        } else {
            first_message = true;
        }
        if (event && event.data.userId) {
            const user_id = event.data.userId == '0' ? "" : event.data.userId
            const user_avatar = event.data.userAvatar == 'default' ? 'africa' : event.data.userAvatar
            const birthplace = event.data.birthplace == 'Unknown' ? 'Los Angeles' : event.data.birthplace
            const motive = event.data.motive == 'None' ? 'Love' : event.data.motive
            const ad_sid = event.data.ad_sid
            let sku_id = ',,' + motive
            if (event.data.skuId == 'None' || event.data.skuId.split(',').length !== 3) {
                sku_id = ',,' + motive
            } else {
                sku_id = event.data.skuId
            }
            const locale = event.data.locale;
            current_locale = locale;
            // star_columns = getStarSigns(locale)
            // gender_columns = getGenderLanguage(locale)
            language_type = getLocaleDescription(locale)
            picker_language = getPickerPhrases(locale)
            this.setState({
                userId: user_id,
                userAvatar: user_avatar,
                birthplace: birthplace,
                motive: motive,
                skuId: sku_id,
                sessionId: sessionId,
                ad_sid: ad_sid,
            }, () => {
                if (this.state.ws) {
                    this.state.ws.close();
                    this.setState({ ws: null }, () => {
                        this.connectWebSocket();
                    });
                } else {
                    this.connectWebSocket();
                }
            });
        } else {
            current_locale = 'en'
            // star_columns = getStarSigns('en')
            // gender_columns = getGenderLanguage('en')
            language_type = getLocaleDescription('en')
            picker_language = getPickerPhrases('en')
            this.setState({
                sessionId: sessionId
            }, () => {
                if (this.state.ws) {
                    this.state.ws.close();
                    this.setState({ ws: null }, () => {
                        this.connectWebSocket();
                    });
                } else {
                    this.connectWebSocket();
                }
            });
        }
    }
    //组件挂载 连接ws
    componentDidMount() {
        if (window.self !== window.top) {
            // 在iframe中 等待父窗口发送消息
            window.addEventListener('message', (event) => {
                if (event) {
                    if (event.data.canLoad == true) {
                        setTimeout(() => {
                            this.handleUserId(event);
                        }, timeoutDuration);
                    }
                }
            });
        } else {
            //不在iframe中 直接加载
            setTimeout(() => {
                const queryParams = new URLSearchParams(window.location.search);
                const aaidValue = queryParams.get('a_aid');
                const email = queryParams.get('email');
                console.log("email",email)
                this.setState({
                    email: email,
                    isValidEmail: false
                })
                if (aaidValue) {
                    const psychic = psychicData.find(item => item.psychic_id === aaidValue);
                    defaultImg = psychic.psychic_avatar
                    headTitleName = psychic.psychic_name
                    roleDefault = psychic.psychic_name
                    psychic_id = psychic.psychic_id
                    if (psychic_id != localStorage.getItem("psychic_id")) {
                        localStorage.removeItem("sessionId")
                        localStorage.removeItem("starmessageList")
                        localStorage.removeItem("bottomList")
                        localStorage.removeItem("zodiacDialogCount")
                        localStorage.removeItem("zodiacInfo")
                        localStorage.removeItem("zodiacCesuanOption")
                        localStorage.removeItem("zodiacReport")
                    }

                    localStorage.setItem("psychic_id", psychic_id)

                    this.setState({
                        helloImage: psychic.psychic_img
                    })
                    this.handleUserId();
                    // axios({
                    //     method: 'get',
                    //     url: httpUrl + '/api/get_id_psychic_manage',
                    //     params: {
                    //         psychic_id: aaidValue,
                    //     }
                    // })
                    //     .then(response => {
                    //         defaultImg = response.data.data.psychic_avatar
                    //         headTitleName = response.data.data.psychic_name
                    //         roleDefault = response.data.data.speaker_name
                    //         psychic_id = response.data.data.id
                    //         this.setState({
                    //             helloImage:response.data.data.psychic_big_image,
                    //         })
                    //         this.handleUserId();
                    //         if (response.data.data.psychic_group == 'Bazi') {
                    //             const redirectUrl = psychic_id ? `/bazi?a_aid=${psychic_id}` : '/bazi';
                    //             window.location.href = redirectUrl;
                    //         }else if(response.data.data.psychic_group == 'Tarot'){
                    //             const redirectUrl = psychic_id ? `/tarot?a_aid=${psychic_id}` : '/tarot';
                    //             window.location.href = redirectUrl;
                    //         }
                    //     })
                    //     .catch(error => {
                    //         console.error(error);
                    //     });
                } else {
                    if (psychic_id != localStorage.getItem("psychic_id")) {
                        localStorage.removeItem("sessionId")
                        localStorage.removeItem("starmessageList")
                        localStorage.removeItem("bottomList")
                        localStorage.removeItem("zodiacDialogCount")
                        localStorage.removeItem("zodiacInfo")
                        localStorage.removeItem("zodiacCesuanOption")
                        localStorage.removeItem("zodiacReport")
                    }
                    this.setState({
                        helloImage: require('../../assets/pyschicImage/sophia_img.png')
                    })
                    this.handleUserId();
                }
            }, timeoutDuration);
        }
        window.addEventListener('pagehide', this.handleBeforeUnload);
        // 添加滚动事件监听器
        const container = this.messagesContainerRef.current;
        if (container) {
            container.addEventListener('scroll', this.handleScroll);
            // 添加 touchstart、touchmove、touchend 事件监听器
            container.addEventListener('touchstart', this.handleTouchStart);
            container.addEventListener('touchmove', this.handleTouchMove);
            container.addEventListener('touchend', this.handleTouchEnd);
        }
        document.addEventListener('visibilitychange', this.handleVisibilityChange);

        // 为输入框添加焦点和失去焦点事件的监听
        const inputField = this.inputFieldRef.current;
        if (inputField) {
            inputField.addEventListener('focus', this.handleFocus);
            inputField.addEventListener('blur', this.handleBlur);
        }
        // 为窗口添加大小变化事件的监听
        window.addEventListener('resize', this.handleResize);

        //获取出生地 国家初始化列表
        this.getCountry();
    }
    handleTouchStart = (event) => {
        // 获取触摸点的初始位置
        startY = event.touches[0].clientY;
    };
    // 触摸移动事件处理函数
    handleTouchMove = (event) => {
        const chatContent = this.messagesContainerRef.current
        // 获取当前触摸点的位置
        const currentY = event.touches[0].clientY;
        // 计算下拉的距离
        const pullDistance = currentY - startY;
        // 如果下拉距离大于 0，并且容器在顶部
        if (pullDistance > 0 && chatContent.scrollTop <= 0) {
            // 阻止浏览器的下拉刷新行为
            if (event.cancelable) {
                event.preventDefault();
            }
            const dampingDistance = pullDistance / 5; // 根据滑动距离计算阻尼距离
            chatContent.style.transition = 'transform 0.3s ease-out';
            chatContent.style.transform = `translate3d(0px, ${dampingDistance}px, 0px)`;
        }
        // 如果上拉距离小于 0，并且容器在底部
        if (pullDistance < 0 && chatContent.scrollHeight - chatContent.scrollTop <= chatContent.clientHeight + 5) {
            // 阻止浏览器的默认行为
            if (event.cancelable) {
                event.preventDefault();
            }
            const dampingDistance = pullDistance / 5; // 根据滑动距离计算阻尼距离
            chatContent.style.transition = 'transform 0.3s ease-out';
            chatContent.style.transform = `translate3d(0px, ${dampingDistance}px, 0px)`;
        }
    };
    // 触摸结束事件处理函数
    handleTouchEnd = () => {
        const chatContent = this.messagesContainerRef.current;
        if (chatContent) {
            chatContent.style.transition = 'transform 0.3s ease-out'; // 过渡效果
            chatContent.style.transform = 'translate3d(0px, 0px, 0px)'; // 恢复原始位置
        }
    };

    // 定义一个函数来调整聊天内容容器的高度
    adjustChatContent = () => {
        if (this.messagesContainerRef.current && this.inputFieldRef.current) {
            // 滚动聊天内容到底部
            this.scrollToBottom()
        }
    };

    // 当输入框获得焦点时
    handleFocus = () => {
        this.adjustChatContent();
        // 向父窗口发送消息
        window.parent.postMessage('Input field focused', '*');
    };
    // 当输入框失去焦点时
    handleBlur = () => {
        // 向父窗口发送消息
        window.parent.postMessage('Input field blurred', '*');
    };
    // 监听窗口大小变化事件
    handleResize = () => {
        setTimeout(() => {
            this.adjustChatContent();
        }, 1000)
    };
    //页面显示监听
    handleVisibilityChange = () => {
        if (document.visibilityState == 'visible') {
            setTimeout(() => {
                this.adjustChatContent();
            }, 500)
        } else {
        }
    }
    //滑动监听
    handleScroll = () => {
        this.setState({
            isBottomVisible: !this.isLastElementVisible()
        });
    }
    //组件卸载 关闭ws
    componentWillUnmount() {
        window.removeEventListener('pagehide', this.handleBeforeUnload);
        const chatContent = this.messagesContainerRef.current;
        if (chatContent) {
            chatContent.removeEventListener('scroll', this.handleScroll);
            chatContent.removeEventListener('touchstart', this.handleTouchStart);
            chatContent.removeEventListener('touchmove', this.handleTouchMove);
            chatContent.removeEventListener('touchend', this.handleTouchEnd);
        }

        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        const inputField = this.inputFieldRef.current;
        if (inputField) {
            inputField.removeEventListener('focus', this.handleFocus);
            inputField.removeEventListener('blur', this.handleBlur);
        }
        window.removeEventListener('resize', this.handleResize);
        // 在组件卸载时移除消息监听器
        window.removeEventListener('message', this.handleUserId);
    }
    handleBeforeUnload = (event) => {
        let exitTime = Math.floor(Date.now() / 1000);
        let duration = exitTime - this.startDialogTime;
        // 如果需要精确显示时间，可以转化为小时、分钟、秒格式
        let hours = Math.floor(duration / 3600);
        let minutes = Math.floor((duration % 3600) / 60);
        let seconds = duration % 60;
        //出站事件 记录
        window.dataLayer.push({
            'custom_user_id': this.getOrCreateUserId(),
            'custom_session_id': this.state.sessionId,
            'event': 'Exit Event',
            'exit_specific_time': new Date(Math.floor(Date.now() / 1000) * 1000).toLocaleString(),
            'chatbot_total_stay_duration': `${hours},${minutes},${seconds}`,
        });
        // 在页面即将被卸载时执行清理操作
        if (this.state.ws) {
            this.state.ws.close();
            this.setState({ ws: null });
        }
    }

    playAudioBuffer = (buffer) => {
        if (source) {
            source.stop(); // 停止之前的音频
            source = null;
        }
        source = audioContext.createBufferSource();
        source.buffer = buffer;
        source.connect(audioContext.destination);
        source.onended = () => {
            if (audioQueue.length > 0) {
                this.processAudioQueue();
            } else {
                isProcessingAudio = false;
                isQueueEmptyAfterProcess = true; // 标记队列处理完成且为空
            }
            if (isQueueEmptyAfterProcess) {
                if (isStopAudio && audioQueue.length == 0) {
                    this.stopAudio(false);
                    //如果当前显示着ASR 则播放结束自动开启录音
                    if (this.state.isShowASR) {
                        this.startAsrRecord();
                    }
                }
            }
        }
        source.start(0);
    }

    createAudioBufferFromPCM(arrayBuffer, sampleRate, numberOfChannels, bitsPerSample) {
        const numberOfFrames = arrayBuffer.byteLength / (bitsPerSample / 8 * numberOfChannels);
        const audioBuffer = audioContext.createBuffer(numberOfChannels, numberOfFrames, sampleRate);

        const view = new Int16Array(arrayBuffer);
        for (let channel = 0; channel < numberOfChannels; channel++) {
            const nowBuffering = audioBuffer.getChannelData(channel);
            for (let frame = 0; frame < numberOfFrames; frame++) {
                nowBuffering[frame] = view[frame * numberOfChannels + channel] / 32768;
            }
        }
        return audioBuffer;
    }

    //ws
    connectWebSocket = () => {
        // const AiMessage = {
        //     type: "sku",
        //     isUser: false,
        //     avator: defaultImg,
        //     botName: this.state.botName,
        //     content: "16068652496499109222303380",
        // }
        // this.setState(prevState => ({
        //     showCursor: false,
        //     showSend: true,
        //     messageList: [...prevState.messageList, AiMessage],
        // }), () => {
        //     this.scrollToBottom();
        // });
        // const userMessage = {
        //     content: 'ssdadadsdasdsa',
        //     isUser: true,
        //     type: 'string',
        // };
        // const aiMessage = {
        //     content: 'You are about to be redirected to a WhatsApp chat. Do you wish to continue?',
        //     isUser: false,
        //     type: 'whatsApp',
        //     avator: defaultImg,
        //     botName: this.state.botName,
        // };
        // this.setState(prevState => ({
        //     showCursor: true,
        //     showSend: false,
        //     messageList: [...prevState.messageList, userMessage, aiMessage],
        // }), () => {
        //     this.scrollToBottom();
        //     this.uploadCache();
        // });

        const { sessionId, userId, userName, userAge, userGender, birthday, userAvatar, birthplace, botName, skuId, preferenceTags, motive, ad_sid } = this.state;
        const queryParams = new URLSearchParams({
            session_id: sessionId,
            user_id: userId,
            user_name: userName,
            user_age: userAge,
            user_gender: userGender,
            birthday: birthday,
            user_avatar: userAvatar,
            birthplace: birthplace,
            bot_name: botName,
            sku_id: skuId,
            motive: motive,
            preference_tags: preferenceTags,
            first_message: first_message,
            language_type: language_type,
            ad_sid: ad_sid,
            psychic_id: psychic_id,
        });
        const websocket = new WebSocketClient(`${wsUrl}?${queryParams.toString()}`);
        this.setState({ ws: websocket });

        websocket.onOpen = () => {
            console.log('WebSocket connected.');
            this.reconnectAttempts = 0;

            // 根据第三位的值设置对应的性别或标识
            var user_gender_on_entry = '';
            if (ad_sid) {
                // 检查 ad_sid 是否至少有三位字符
                if (ad_sid.length >= 3) {
                    var thirdChar = ad_sid.charAt(2);  // 取得第三个字符
                    switch (thirdChar) {
                        case '1':
                            user_gender_on_entry = 'male';
                            break;
                        case '0':
                            user_gender_on_entry = 'female';
                            break;
                        case '2':
                            user_gender_on_entry = 'all';
                            break;
                        case '3':
                            user_gender_on_entry = 'other';
                            break;
                        default:
                            user_gender_on_entry = 'unknown'; // 如果第三位不符合预期值，设为未知
                            break;
                    }
                }
            }
            this.startDialogTime = Math.floor(Date.now() / 1000);
            //ws 建立连接 标识开始进站 记录入站事件
            window.dataLayer.push({
                'custom_user_id': this.getOrCreateUserId(),
                'custom_session_id': sessionId,
                'event': 'Start Dialog',
                'Page title': document.title,
                'user_source': (new URL(document.location)).searchParams.get('utm_source') || 'Direct',
                'user_device_type': this.getDeviceAndBrowserInfo().deviceType,
                'user_browser_type': this.getDeviceAndBrowserInfo().browserType,
                'user_gender_on_entry': user_gender_on_entry,
                'entry_geolocation': '',
                'ip_geolocation': '',
                'entry_specific_time': new Date(Math.floor(Date.now() / 1000) * 1000).toLocaleString()
            });
        };
        websocket.onMessage = (data) => {
            // 处理接收到的消息
            // 普通message消息文本 code=1001
            // 星座开场招呼语询问性别血型 code=1002
            // 询问选择星座 code=2001
            // 返回星座信息 code=2002
            // 八字询问性别 code=3001
            // 八字询问生日 code=3002
            // type=“string” 表示以上内容
            // type=“sku” 表示商品
            // type=“loading” 表示加载中（前端展示）
            try {
                if (data instanceof Blob) {
                    // Received Blob data
                    const fileReader = new FileReader();
                    fileReader.onload = (e) => {
                        const arrayBuffer = e.target.result;
                        audioQueue.push(arrayBuffer)
                        // 如果没有正在处理消息，则开始处理队列
                        if (!isProcessingAudio) {
                            this.processAudioQueue();
                        }
                    };
                    fileReader.readAsArrayBuffer(data);
                } else if (data instanceof ArrayBuffer) {
                    this.setState({
                        showAudioLoading: false
                    })
                    // Received ArrayBuffer data
                    audioQueue.push(data)
                    // 如果没有正在处理消息，则开始处理队列
                    if (!isProcessingAudio) {
                        this.processAudioQueue();
                    }
                } else {
                    const messageData = JSON.parse(data);
                    //如果当前到了选择用户信息阶段 用一个字段来表示当前状态
                    if (messageData.code == 1002 || messageData.code == 2001 || messageData.code == 2002 || messageData.code == 3001 || messageData.code == 3002) {
                        isFill_in = true;
                    }
                    messageQueue.push(messageData);
                    // 如果没有正在处理消息，则开始处理队列
                    if (!isProcessing) {
                        this.processMessageQueue();
                    }
                }

            } catch (error) {

            }
        };

        websocket.onClose = () => {
            console.error('WebSocket disconnected.');
            //this.showErrorMessage()
        };

        websocket.onError = (error) => {
            console.error('WebSocket error:', error);
            //TODO 用于测试
            // localStorage.removeItem("sessionId")
            // localStorage.removeItem("starmessageList")
            // localStorage.removeItem("bottomList")
            // localStorage.removeItem("zodiacDialogCount")
            // localStorage.removeItem("zodiacInfo")
            // localStorage.removeItem("zodiacCesuanOption")
            // this.setState({
            //     messageList:[],
            // })
            if (!connection_loading) {
                const loadingElement = document.querySelector('.connection_loading');
                if (loadingElement) {
                    loadingElement.style.display = 'none';
                }
                connection_loading = true;
            }
            if (this.state.ws) {
                if (this.reconnectAttempts < this.MAX_RECONNECT_ATTEMPTS) {
                    console.log(`Reconnecting in ${this.RECONNECT_INTERVAL} milliseconds...`);
                    setTimeout(() => {
                        this.reconnectAttempts = this.reconnectAttempts + 1;
                        this.connectWebSocket();
                    }, this.RECONNECT_INTERVAL);
                } else {
                    console.log('Max reconnect attempts reached. Stop reconnecting.');
                }
            }
            //this.showErrorMessage()
        };

        websocket.connect();

    }
    // 处理音频流队列函数
    processAudioQueue = () => {
        if (audioQueue.length === 0) {
            isProcessingAudio = false;
            isQueueEmptyAfterProcess = true; // 标记队列已处理完且为空
            return;
        }

        isProcessingAudio = true;
        isQueueEmptyAfterProcess = false; // 处理过程中设置为 false

        const audioBuffer = audioQueue.shift(); // 从队列中取出第一个消息
        try {
            const audio = this.createAudioBufferFromPCM(audioBuffer, 44100, 1, 16);
            this.playAudioBuffer(audio);
        } catch (error) {
            console.error('Error handling message:', error);
        }
    }
    // 处理消息队列函数
    processMessageQueue = () => {
        if (messageQueue.length === 0) {
            isProcessing = false;
            return;
        }
        isProcessing = true;
        const message = messageQueue.shift(); // 从队列中取出第一个消息
        try {
            this.handleMessage(message);
        } catch (error) {
            console.error('Error handling message:', error);
        }
        // 继续处理下一个消息，或者等待下一个定时器触发
        intervalId = setTimeout(this.processMessageQueue, delay);
    }
    // 在必要时停止处理消息队列，清除定时器等
    stopProcessing = () => {
        clearTimeout(intervalId);
        isProcessing = false;
        messageQueue = [];
    }
    //展示一条错误信息
    showErrorMessage = () => {
        //将一些用于判断的字段 置为初始状态
        count = 0
        newMessage = ''
        canSend = true
        const errorMessage = {
            content: 'Sorry for encountering an error temporarily!',
            isUser: false,
            type: 'string',
            avator: defaultImg,
            botName: this.state.botName,
        };
        this.setState(prevState => {
            const { messageList } = prevState;
            const lastIndex = messageList.length - 1;
            const lastMessage = messageList[lastIndex];
            const shouldRemoveLastMessage = lastMessage && lastMessage.type == "loading";
            const newMessageList = shouldRemoveLastMessage ? messageList.slice(0, lastIndex) : [...messageList];

            return {
                showCursor: false,
                showSend: true,
                messageList: [...newMessageList, errorMessage],
            }
        }, () => {
            this.scrollToBottom();
            this.uploadCache();
        });
    }
    //处理接收到的消息
    handleMessage = (messageData) => {
        // 解构赋值从 messageData 对象中提取所需的属性
        const { code, end, type, content, bot_name, session_id } = messageData;
        if (end == true) {
            window.dataLayer.push({
                'custom_user_id': this.getOrCreateUserId(),
                'custom_session_id': this.state.sessionId,
                'event': 'Bot Response Message',
                'interaction_timestamp': new Date(Math.floor(Date.now() / 1000) * 1000).toLocaleString(),
            });
        }
        // 更新消息列表的函数
        const handleMessageListUpdate = (newMessageItem, isEnd) => {
            this.setState(prevState => {
                const { messageList } = prevState;
                const lastIndex = messageList.length - 1;
                const lastMessage = messageList[lastIndex];
                const shouldRemoveLastMessage = lastMessage && lastMessage.type == "loading";
                const newMessageList = shouldRemoveLastMessage ? messageList.slice(0, lastIndex) : [...messageList];

                if (newMessageItem.category != '') {
                    if (newMessageItem.category == 9000) {
                        return {
                            showCursor: !isEnd,
                            showSend: isEnd && canSend,
                            messageList: newMessageList.map((item, index) =>
                                index === newMessageList.length - 1 ?
                                    {
                                        ...item,
                                        category: newMessageItem.category,
                                        moreContent: '',
                                        cesuan_hide_key: messageData.msg,
                                        isShowDetail: false
                                    } :
                                    item
                            )
                        };
                    }
                    // 当 category 是特殊类型且 content 为空时，更新最后一条消息
                    const isSpecialCategory = [1002, 2001, 2003].includes(newMessageItem.category);
                    if (isSpecialCategory && newMessageItem.content == '') {
                        return {
                            showCursor: !isEnd,
                            showSend: isEnd && canSend,
                            messageList: newMessageList.map((item, index) =>
                                index === newMessageList.length - 1 ?
                                    { ...item, category: newMessageItem.category } :
                                    item
                            )
                        };
                    } else if (newMessageItem.content != '') {
                        // 当 content 不为空时，新增条目
                        return {
                            showCursor: !isEnd,
                            showSend: isEnd && canSend,
                            messageList: [
                                ...newMessageList,
                                newMessageItem,
                            ],
                        };
                    }
                }
                return {
                    showCursor: !isEnd,
                    showSend: isEnd && canSend,
                    botName: bot_name,
                    sessionId: session_id,
                };
            }, () => {
                if (!this.state.isBottomVisible) {
                    this.scrollToBottom();
                    if (newMessageItem.category == 1002 || newMessageItem.category == 2001 || newMessageItem.category == 2003 || newMessageItem.category == 9020 || newMessageItem.category == 1001) {
                        setTimeout(() => {
                            this.scrollToBottom();
                        }, 1000);
                    }
                }
                this.uploadCache();
            });
        };
        // type=sessionId的处理
        const handleTypeSessionId = () => {
            if (this.state.sessionId == session_id) {
                const loaclMessageList = JSON.parse(localStorage.getItem("starmessageList")) || [];
                const userGender = localStorage.getItem("userGender");
                const userBloodType = localStorage.getItem("userBloodType");
                const userBirthday = localStorage.getItem("userBirthday");
                const userSign = localStorage.getItem("userSign");

                this.setState(prevState => ({
                    sessionId: session_id,
                    messageList: loaclMessageList,
                    newGender: userGender ? userGender : prevState.newGender,
                    newBloodType: userBloodType ? userBloodType : prevState.newBloodType,
                    newBirthdayShow: userBirthday !== '',
                    newBirthday: userBirthday ? userBirthday : prevState.newBirthday,
                    activeSign: userSign ? userSign : prevState.activeSign,
                }), () => {
                    // 更新完成后，设置聊天加载状态为 false
                    this.setState({ isChatLoading: false });

                    // 1 秒后滚动到底部
                    setTimeout(() => {
                        this.scrollToBottom();
                    }, 1000);
                });
            } else {
                this.setState({
                    sessionId: session_id,
                    isChatLoading: false,
                })
                localStorage.removeItem("sessionId")
                localStorage.removeItem("starmessageList")
                localStorage.removeItem("bottomList")
                localStorage.removeItem("zodiacDialogCount")
                localStorage.removeItem("zodiacInfo")
                localStorage.removeItem("zodiacCesuanOption")
                localStorage.removeItem("zodiacReport")

            }
        }
        // type=FortuneTellerName
        const handleTypeFortuneTellerName = () => {
            this.setState({ FortuneTellerName: content });
        }
        // type=string
        const handleTypeString = () => {
            if (code == 1001 || code == 1002 || code == 2001 || code == 2003 || code == 9000) {
                if (end == false) {
                    // 如果消息未结束
                    if (newMessage) {
                        newMessage += content; // 将消息内容添加到新消息中
                    } else {
                        newMessage = content; // 否则设置新消息内容
                    }
                    if (count == 0) {
                        count++;
                        canSend = false; // 设置不可发送
                        this.updateNum = 0; // 重置更新计数器
                        // 更新消息列表
                        handleMessageListUpdate({
                            type: "string",
                            isUser: false,
                            avator: defaultImg,
                            botName: bot_name,
                            category: code,
                            content: newMessage,
                        }, false);
                    } else {
                        // 更新消息列表中最后一条消息的内容
                        this.setState((prevState) => ({
                            messageList: prevState.messageList.map((message, index) => {
                                if (index === prevState.messageList.length - 1) {
                                    return {
                                        ...message,
                                        content: newMessage,
                                    };
                                }
                                return message;
                            })
                        }), () => {
                            // 更新计数器并根据情况滚动到底部或刷新滚动区域
                            this.updateNum++;
                            if (!this.state.isBottomVisible && this.updateNum % 20 === 0) {
                                this.scrollToBottom();
                            }
                        });
                    }
                } else if (end == true) {
                    handleMessageListUpdate({
                        type: "string",
                        isUser: false,
                        avator: defaultImg,
                        botName: bot_name,
                        category: code,
                        content: content,
                    }, true);
                    //设置可以发送消息
                    canSend = true;
                    // 重置新消息和计数器
                    newMessage = "";
                    count = 0;
                }
            }
            switch (code) {
                //普通message文本消息 
                case 1001:
                    break;
                //询问血型和生日信息
                case 1002:
                    if (end == true) {
                        //信息填写表单的开始事件
                        window.dataLayer.push({
                            'custom_user_id': this.getOrCreateUserId(),
                            'custom_session_id': this.state.sessionId,
                            'event': 'Fill in information',
                            'info_page_event_trigger_time': new Date(Math.floor(Date.now() / 1000) * 1000).toLocaleString(),
                        });
                    }
                    break;
                //询问性别和星座信息
                case 2001:
                    break;
                case 2003:
                    break;
                //选择生日后返回星座的信息
                case 2002:
                    break;
                //是否确认商推
                case 4001:
                    this.setState({
                        isShowYesNo: true
                    })
                    break;
                //展示测算的隐藏内容
                case 9100:
                    canSend = true;
                    this.setState(prevState => {
                        const updatedMessageList = prevState.messageList.map((item, i) => {
                            if (i === starDiskIndex) {
                                return {
                                    ...item,
                                    isShowDetail: true,
                                    moreContent: content,
                                    showCursor: false,
                                };
                            }
                            return item;
                        });
                        return { messageList: updatedMessageList };
                    })
                    break;
            }
        }
        // type=hide
        const handleTypeHide = () => {
            if (end == false) {
                if (newMessage != "") {
                    newMessage += content; // 将消息内容添加到新消息中
                } else {
                    newMessage = content; // 否则设置新消息内容
                }
                if (count == 0) {
                    count++;
                    canSend = false; // 设置不可发送
                    this.updateNum = 0; // 重置更新计数器
                    handleMessageListUpdate({
                        type: "hide",
                        isUser: false,
                        avator: defaultImg,
                        botName: bot_name,
                        category: code,
                        content: newMessage,
                    }, false);
                } else {
                    let updateMessage = newMessage
                    if (/\n/.test(content)) {
                        // 检查是否包含除 \n 之外的字符
                        if (/[^\n]/.test(content)) {
                            updateMessage = newMessage.replace(/\n/g, "");
                        } else {
                            updateMessage = "";
                        }
                        count = 0;
                        newMessage = "";
                    }
                    // 更新消息列表中最后一条消息的内容
                    this.setState((prevState) => ({
                        messageList: prevState.messageList.map((message, index) => {
                            if (index === prevState.messageList.length - 1) {
                                if (updateMessage != "") {
                                    return {
                                        ...message,
                                        content: updateMessage,
                                    };
                                }
                            }
                            return message;
                        })
                    }), () => {
                        // 更新计数器并根据情况滚动到底部或刷新滚动区域
                        this.updateNum++;
                        if (!this.state.isBottomVisible && this.updateNum % 20 === 0) {
                            this.scrollToBottom();
                        }

                    });
                }
            } else if (end == true) {
                handleMessageListUpdate({
                    type: "hide",
                    isUser: false,
                    avator: defaultImg,
                    botName: bot_name,
                    category: code,
                    content: content,
                }, true);
                //设置可以发送消息
                canSend = true;
                // 重置新消息和计数器
                newMessage = "";
                count = 0;
                this.updateNum = 0;
            }
        }
        //type=star_pic
        const handleTypeStarPic = () => {
            if (code == 9020) {
                handleMessageListUpdate({
                    type: "star_pic",
                    category: code,
                    isUser: false,
                    avator: defaultImg,
                    botName: bot_name,
                    isShowDetail: false,
                    showCursor: false,
                    moreContent: '',
                    content: JSON.parse(content),
                }, true);
            } else if (code == 9021) {
                canSend = true;
                this.setState(prevState => {
                    const updatedMessageList = prevState.messageList.map((item, i) => {
                        if (i === starDiskIndex) {
                            return {
                                ...item,
                                isShowDetail: true,
                                moreContent: content,
                                showCursor: false,
                            };
                        }
                        return item;
                    });
                    return { messageList: updatedMessageList };
                })
            }
        }
        // type=sku
        const handleTypeSku = () => {
            handleMessageListUpdate({
                type: "sku",
                isUser: false,
                avator: defaultImg,
                botName: bot_name,
                content: content,
            }, true);
            //获取pc端商品数据
            //this.pcHttpSku(JSON.parse(content))
        }
        // 逻辑新
        switch (type) {
            //hello 招呼语样式展示
            case 'hello':
                this.setState({
                    isHelloView: true,
                })
                //this.getTipsList('', 'first_stage')
                //招呼事件记录
                window.dataLayer.push({
                    'custom_user_id': this.getOrCreateUserId(),
                    'custom_session_id': this.state.sessionId,
                    'event': 'Hello Event',
                    'greeting_page_event_trigger_time': new Date(Math.floor(Date.now() / 1000) * 1000).toLocaleString(),
                });
                break;
            //again
            case 'again':
                this.setState({
                    isHelloView: false,
                })
                // 移除具有 className 为 'connection_loading' 的元素
                if (!connection_loading) {
                    const loadingElement = document.querySelector('.connection_loading');
                    if (loadingElement) {
                        loadingElement.style.display = 'none';
                    }
                    connection_loading = true;
                }
                break;
            //聊天session_id的返回
            case 'session_id':
                handleTypeSessionId();
                break;
            //头部 角色名称返回
            case 'FortuneTellerName':
                handleTypeFortuneTellerName();
                break;
            //文本消息类型 end标识(true消息结束 false消息正在返回)
            case 'string':
                handleTypeString();
                break;
            //商品消息
            case 'sku':
                handleTypeSku();
                break;
            //折行消息
            case 'hide':
                // 移除具有 className 为 'connection_loading' 的元素
                if (!connection_loading) {
                    const loadingElement = document.querySelector('.connection_loading');
                    if (loadingElement) {
                        loadingElement.style.display = 'none';
                    }
                    connection_loading = true;
                }
                handleTypeHide();
                break;
            //星盘消息
            case 'star_pic':
                handleTypeStarPic();
                //开始占卜的事件记录
                window.dataLayer.push({
                    'custom_user_id': this.getOrCreateUserId(),
                    'custom_session_id': this.state.sessionId,
                    'event': 'Divination Event',
                    'fortune_telling_page_event_trigger_time': new Date(Math.floor(Date.now() / 1000) * 1000).toLocaleString(),
                    'fortune_telling_type': document.title,
                });
                break;
            //语音播放停止
            case 'stop_audio':
                isStopAudio = true;
                break;
            //显示点赞拉踩
            case 'diss':
                handleMessageListUpdate({
                    type: "diss",
                    category: code,
                    content: content,
                    msg: messageData.msg,
                    zan: false,
                    cai: false,
                }, true);
                break;
        }
    };
    // 判断最后一个元素是否可见
    isLastElementVisible = () => {
        if (this.messagesContainerRef.current) {
            const lastElement = this.messagesContainerRef.current.lastElementChild;
            if (lastElement) {
                const rect = lastElement.getBoundingClientRect();
                return rect.bottom <= window.innerHeight;
            }
        }
        return false;
    }
    //滚动到底部
    scrollToBottom = () => {
        const container = this.messagesContainerRef.current
        if (container) {
            container.scrollTop = container.scrollHeight;
        }
    }
    //发送消息
    sendMessage(messageContent, asrText) {
        //三轮对话限制
        let count = parseInt(localStorage.getItem('zodiacDialogCount') || '0', 10);
        if (count < 3) {
            count++;
            localStorage.setItem('zodiacDialogCount', count);
        } else {
            const userMessage = {
                content: messageContent,
                isUser: true,
                type: 'string',
            };
            const aiMessage = {
                content: 'This product is the best solution for your current problem. If you have further questions, contact our professionals.',
                isUser: false,
                type: 'whatsApp',
                avator: defaultImg,
                botName: this.state.botName,
            };
            this.setState(prevState => ({
                showCursor: false,
                showSend: true,
                messageList: [...prevState.messageList, userMessage, aiMessage],
            }), () => {
                this.scrollToBottom();
                this.uploadCache();
            });
            return;
        }

        window.dataLayer.push({
            'custom_user_id': this.getOrCreateUserId(),
            'custom_session_id': this.state.sessionId,
            'event': 'User Send Message',
            'interaction_timestamp': new Date(Math.floor(Date.now() / 1000) * 1000).toLocaleString(),
        });
        if (this.state.isHelloView) {
            this.setState({
                isHelloView: false,
            })
        }
        if (this.popoverRef.current) {
            this.popoverRef.current.hide();
        }
        const { ws } = this.state;
        canSend = false;
        const userMessage = {
            content: messageContent,
            isUser: true,
            type: 'string',
        };
        const aiMessage = {
            content: '',
            isUser: false,
            type: 'loading',
            avator: defaultImg,
            botName: this.state.botName,
            loadingText: 'cosmic answers are on the way....'
        };
        this.setState(prevState => ({
            showCursor: true,
            showSend: false,
            messageList: [...prevState.messageList, userMessage, aiMessage],
        }), () => {
            if (asrText) {
                ws.send(asrText)
            } else {
                ws.send(messageContent);
            }
            this.scrollToBottom();
            this.uploadCache();
        });
    }
    //上传缓存
    uploadCache() {
        let loaclMessageList = this.state.messageList
        loaclMessageList = loaclMessageList.filter(message => message.type !== "loading");
        while (loaclMessageList.length >= 20) {
            loaclMessageList.shift();
        }
        localStorage.setItem("starmessageList", JSON.stringify(loaclMessageList));
        localStorage.setItem("sessionId", this.state.sessionId)
        first_message = false;
    }
    handlePopState(event) {
        // 隐藏 iframe 并显示父组件内容
        if (this.state.iframeVisible) {
            this.setState({
                iframeVisible: false,
            });
        }
    }
    //是否同意
    sendBtnYesNo = (value, labelText) => {
        let content;
        if (value == 'yes') {
            content = 'YES'
            this.setState({
                isShowYesNo: false,
            })
            //开始商推的事件记录
            window.dataLayer.push({
                'custom_user_id': this.getOrCreateUserId(),
                'custom_session_id': this.state.sessionId,
                'event': 'Business Promotion',
                'promotion_page_event_trigger_time': new Date(Math.floor(Date.now() / 1000) * 1000).toLocaleString(),
            });
        } else if (value == 'no') {
            content = 'No'
            this.setState({
                isShowYesNo: false,
            })
        }
        const userMessage = {
            content: labelText,
            isUser: true,
            type: 'string',
        };
        const aiMessage = {
            content: '',
            isUser: false,
            type: 'loading',
            avator: defaultImg,
            botName: this.state.botName,
            loadingText: 'cosmic answers are on the way....'
        };
        this.setState(prevState => ({
            showCursor: true,
            showSend: false,
            messageList: [...prevState.messageList, userMessage, aiMessage],
        }), () => {
            this.state.ws.send(value);
            this.scrollToBottom();
            this.uploadCache();
        });
    }
    //显示星盘解读信息
    showMore = (index, md5_hash, cesuan_hide_key) => {
        //当前没有内容输出的时候 可以触发展示星盘解读信息
        if (canSend) {
            if (md5_hash != '') {
                //this.state.ws.send('{"md5_hash": "' + md5_hash + '"}');
                const zodiacReport = localStorage.getItem('zodiacReport')
                console.log('zodiacReport', zodiacReport)
                if (zodiacReport) {
                    this.setState({
                        sendSuccessVisible: true,
                        sendEmailVisible: false,
                    })
                } else {
                    this.setState({
                        sendEmailVisible: true,
                        sendSuccessVisible: false,
                    })
                }
                email_hash = md5_hash
            }
            if (cesuan_hide_key != '') {
                canSend = false;
                this.state.ws.send('{"cesuan_hide_key": "' + cesuan_hide_key + '"}');
            }
            starDiskIndex = index;
            this.setState(prevState => {
                const updatedMessageList = prevState.messageList.map((item, i) => {
                    if (i === index) {
                        return {
                            ...item,
                            isShowDetail: true,
                            //showCursor: true,
                        };
                    }
                    return item;
                });
                return { messageList: updatedMessageList };
            })
        }
    }
    hideEmailPop = () => {
        this.setState({
            sendEmailVisible: false,
        })
        this.setState(prevState => {
            const updatedMessageList = prevState.messageList.map((item, i) => {
                if (i === starDiskIndex) {
                    return {
                        ...item,
                        isShowDetail: false,
                    };
                }
                return item;
            });
            return { messageList: updatedMessageList };
        })
    }
    hideSuccessPop = () => {
        this.setState({
            sendSuccessVisible: false,
        })
    }
    handleEmailChange = (event) => {
        const email = event.target.value;
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const isValidEmail = !emailPattern.test(email);
        this.setState({
            email,
            isValidEmail,
        })
    };
    handleEmailSubmit = () => {
        this.state.ws.send('{"email": "' + this.state.email + '","md5_hash": "' + email_hash + '"}');
        //统计获取邮箱提交事件
        window.dataLayer.push({
            'custom_user_id': this.getOrCreateUserId(),
            'custom_session_id': this.state.sessionId,
            'event': 'Get report',
            'email_subscription_form_field_value': this.state.email,
        });
        this.setState({
            sendEmailVisible: false,
            sendSuccessVisible: true,
        })
        this.setState(prevState => {
            const updatedMessageList = prevState.messageList.map((item, i) => {
                if (i === starDiskIndex) {
                    return {
                        ...item,
                        isShowDetail: true,
                    };
                }
                return item;
            });
            return { messageList: updatedMessageList };
        })
        localStorage.setItem('zodiacReport', true)
    }
    showVoiceView = async () => {
        if (isFill_in) {
            return; // 如果 isFill_in 为 true，则不执行发送消息的操作
        }
        //三轮对话限制
        let count = parseInt(localStorage.getItem('zodiacDialogCount') || '0', 10);
        if (count < 3) {
            this.requestMicrophoneAccess();
        }
    }
    //拉起麦克风权限
    requestMicrophoneAccess = async () => {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            console.error('getUserMedia is not supported in this browser.');
            alert('Your browser does not support microphone access function. Please change your browser or check the environment configuration.');
            return;
        }
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            stream.getTracks().forEach(track => track.stop());
            this.setState({
                isShowVoice: true,
            })
        } catch (error) {
            console.error('Microphone access denied or error occurred:', error);
        }
    };
    hideVoiceView = () => {
        this.setState({
            isShowVoice: false,
        })
    }
    startRecording = () => {
        recordText = ""
        this.setState({
            isRecording: true,
            vadDelay: 100000,
        })
        this.stopAudio(true);
    }
    stopRecording = () => {
        this.setState({
            isRecording: false
        })
    }
    //asr开始录音
    startAsrRecord = (value) => {
        this.stopAudio(true);
        recordText = ""
        this.setState({
            isRecording: true,
            vadDelay: value,
        })
    }
    cancelRecording = () => {
        this.setState({
            isRecording: false
        })
    }
    //触发播放语音
    playAudio = (content, index) => {
        if (Math.abs(debounceStopAudio - Date.now()) > 500) {
            debounceStopAudio = Date.now();
            if (canSend) {
                this.stopAudio(true)
                this.state.ws.send('{"text": "' + content + '","speaker_name":"' + roleDefault + '"}')
                this.setState({
                    playAudioIndex: index,
                    showAudioLoading: true
                })
            }
        }
    }
    //触发停止播放语音
    stopAudio = (stop) => {
        if (source) {
            source.stop();
            source = null;
            audioQueue = [];
        }
        if (stop) {
            this.state.ws.send('{"is_stop_tts":"stop_tts"}')
        }
        this.setState({
            playAudioIndex: -1,
            showAudioLoading: false
        })
        isStopAudio = false
    }
    onDataAvailable = (data) => {
        recordText = data
    }
    onVolumeValue = (value) => {
        this.setState({
            volume: value
        })
    }
    onStop = (data) => {
        //静默时间导致停止通知语音控件复原
        this.setState({ vadEnd: true, isRecording: false, showAudioLoading: true })
        if (recordText != '' && recordText.length != 0) {
            if (this.state.isShowASR) {
                const asrText = `{"text":"${recordText}","speaker_name":"North_America_Female_Jennifer_Lawrence_First_choice","tts_code_message_set":"asr_return_voice_and_text"}`
                this.sendMessage(recordText, asrText)
            } else {
                this.sendMessage(recordText)
            }
        } else {
            console.log("录音结束，没有录音内容")
            //如果asr 识别的内容为空 则重新开启录音
            if (this.state.isShowASR) {
                setTimeout(() => {
                    this.startAsrRecord()
                }, 1000);
            }
        }
    }
    //联想词提示
    getTipsList = (user_input, stage) => {
        axios({
            method: 'get',
            url: httpUrl + '/api/associative_words',
            params: {
                "user_id": this.state.userId,
                "session_id": this.state.sessionId,
                "user_gender": this.state.newGender,
                "preference_tags": this.state.preferenceTags,
                "language_type": language_type,
                "user_input": user_input,
                "stage": stage,
            }
        })
            .then(response => {
                this.setState({
                    tipsList: response.data.data
                })
            })
            .catch(error => {
                console.error(error);
            });

    }
    //商品详情iframe
    showProductDetail = (url) => {
        this.setState({
            iframeSrc: url,
            isShowProduct: true
        })
    }
    //点赞拉踩
    confirmDiss = (index, content, status_int) => {
        axios({
            method: 'post',
            url: httpUrl + '/api/dtc_like_and_dislike',
            data: {
                "user_id": this.state.userId,
                "session_id": this.state.sessionId,
                "user_gender": this.state.newGender,
                "preference_tags": this.state.preferenceTags,
                "language_type": language_type,
                "content": content,
                "status_int": status_int,
            }
        })
            .then(response => {
                if (response.data.status_code == 200) {
                    this.setState(prevState => {
                        const updatedMessageList = prevState.messageList.map((item, i) => {
                            if (i === index) {
                                switch (status_int) {
                                    case 1:
                                        return {
                                            ...item,
                                            zan: true,
                                        };
                                    case 2:
                                        return {
                                            ...item,
                                            cai: true,
                                        };
                                    case 3:
                                        return {
                                            ...item,
                                            zan: false,
                                        }
                                    case 4:
                                        return {
                                            ...item,
                                            cai: false,
                                        }

                                }
                            }
                            return item;
                        });
                        return { messageList: updatedMessageList };
                    })
                }
            })
            .catch(error => {
                console.error(error);
            });
    }
    //换一批商品
    changeGoods = (value) => {
        const userMessage = {
            content: getOtherConfig(current_locale)[4],
            isUser: true,
            type: 'string',
        };
        const aiMessage = {
            content: '',
            isUser: false,
            type: 'loading',
            avator: defaultImg,
            botName: this.state.botName,
            loadingText: 'cosmic answers are on the way....'
        };
        this.setState(prevState => ({
            showCursor: true,
            showSend: false,
            messageList: [...prevState.messageList, userMessage, aiMessage],
        }), () => {
            this.state.ws.send(value);
            this.scrollToBottom();
            this.uploadCache();
        });
    }
    handleRoleConfirm = (value) => {
        roleDefault = value
    }
    roleClick = () => {
        //TODO 停电
        return
        // if (this.roleRef.current) {
        //     this.roleRef.current.open()
        // }
        //打开ASR 并且开启录音
        recordText = ''
        this.setState({
            isShowASR: true,
            isRecording: true,
            vadDelay: 2000,
        })
    }
    onCloseAsrPop = () => {
        this.setState({
            isShowASR: false,
            isRecording: false,
        })
        this.stopAudio(true)
    }
    //点击招呼页面开始聊天按钮
    handleHelloViewChange = () => {
        this.setState({
            isHelloView: false,
        })
    }
    //点击星座列表的选项
    handleSignClick = (sign) => {
        this.setState({
            activeSign: sign
        })
    };
    //点击开始信息填写页面和隐藏
    showFillInInformation = () => {
        if (localStorage.getItem('zodiacInfo')) {
            Toast.info("Single calculations only. Contact customer service for custom options.")
            return;
        }
        this.setState({
            showInfoFrom: true
        })
    }
    //生日格式转换 前端展示
    formatDateTime(date) {
        if (!date) return '';
        let dateobj = new Date(date);
        // 获取日期部分
        const day = String(dateobj.getDate()).padStart(2, '0');
        const month = String(dateobj.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始
        const year = dateobj.getFullYear();

        // 获取时间部分
        const hours = String(dateobj.getHours()).padStart(2, '0');
        const minutes = String(dateobj.getMinutes()).padStart(2, '0');
        const seconds = String(dateobj.getSeconds()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }
    //生日格式转换 后端需要
    formatDateTimeToBackend(date) {
        if (!date) return '';

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，所以加 1
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    //发送用户信息表单数据
    sendUserInfo = () => {
        if (!this.state.newBirthday || !this.state.activeSign || !this.state.city) {
            Toast.info('Please fill in everything');
            return;
        }
        isFill_in = false
        this.setState({
            showInfoFrom: false,
        })
        //对话轮数+1
        let count = parseInt(localStorage.getItem('zodiacDialogCount') || '0', 10);
        if (count < 3) {
            count++;
            localStorage.setItem('zodiacDialogCount', count);
        }

        localStorage.setItem("zodiacInfo", true);
        localStorage.setItem("userGender", this.state.newGender);
        localStorage.setItem("userBloodType", this.state.newBloodType);
        localStorage.setItem("userBirthday", this.state.newBirthday);
        localStorage.setItem("userSign", this.state.activeSign);


        const { userId, userName, userAge, userAvatar, birthplace, preferenceTags, ws, newGender, newBloodType, newBirthday, activeSign } = this.state;
        const userMessage = {
            newGender: newGender,
            newBloodType: newBloodType,
            newBirthday: this.formatDateTime(new Date(newBirthday)),
            newSign: activeSign,
            content: '',
            isUser: true,
            type: 'info',
        };
        const aiMessage = {
            content: '',
            isUser: false,
            type: 'loading',
            avator: defaultImg,
            botName: this.state.botName,
            loadingText: headTitleName + ' is aligning your stars....'
        };
        this.setState(prevState => ({
            showCursor: true,
            showSend: false,
            messageList: [...prevState.messageList, userMessage, aiMessage],
        }), () => {
            //ws.send(newGender + "," + newBloodType + "," + this.formatDateTime(new Date(newBirthday)) + "," + activeSign)
            this.scrollToBottom();
            this.uploadCache();
        });

        //发送给后端
        const userINFO = {
            user_id: userId,
            user_name: userName,
            user_age: userAge,
            user_gender: newGender,
            blood_type: newBloodType,
            zodiac: activeSign,
            birthday: this.formatDateTimeToBackend(new Date(newBirthday)),
            user_avatar: userAvatar,
            birthplace: this.state.city,
            lat: this.state.lat,
            lng: this.state.long,
            preference_tags: preferenceTags,
        };
        ws.send(JSON.stringify(userINFO));

        window.dataLayer.push({
            'custom_user_id': this.getOrCreateUserId(),
            'custom_session_id': this.state.sessionId,
            'user_gender_in_info': newGender,
            'user_bloodtype_in_info': newBloodType,
            'user_starsign_in_info': activeSign,
            'user_birthday_in_info': this.formatDateTimeToBackend(new Date(newBirthday)),
            'user_age_in_info': ageUtils.calculateAge(this.formatDateTimeToBackend(new Date(newBirthday))),
            'event': 'Fill in information',
            'info_form_field_name': 'user_gender_in_info',
            'info_form_field_value': newGender,
        });

        window.dataLayer.push({
            'event': 'Fill in information',
            'info_form_field_name': 'user_birthday_in_info',
            'info_form_field_value': this.formatDateTimeToBackend(new Date(newBirthday)),
        });
        window.dataLayer.push({
            'event': 'Fill in information',
            'info_form_field_name': 'user_bloodtype_in_info',
            'info_form_field_value': newBloodType,
        });
        window.dataLayer.push({
            'event': 'Fill in information',
            'info_form_field_name': 'user_starsign_in_info',
            'info_form_field_value': activeSign,
        });
    }
    getZodiacSign(date) {
        const month = date.getMonth() + 1; // 月份从0开始
        const day = date.getDate();
        if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) {
            return 'Aries';
        } else if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) {
            return 'Taurus';
        } else if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) {
            return 'Gemini';
        } else if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) {
            return 'Cancer';
        } else if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) {
            return 'Leo';
        } else if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) {
            return 'Virgo';
        } else if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) {
            return 'Libra';
        } else if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) {
            return 'Scorpio';
        } else if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) {
            return 'Sagittarius';
        } else if ((month === 12 && day >= 22) || (month === 1 && day <= 19)) {
            return 'Capricorn';
        } else if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) {
            return 'Aquarius';
        } else if ((month === 2 && day >= 19) || (month === 3 && day <= 20)) {
            return 'Pisces';
        }
        return '';
    }
    //确定生日选择
    confirmeBirthday = () => {
        this.setState({
            showBirthdayPicker: false,
            newBirthdayShow: true,
            activeSign: this.getZodiacSign(this.state.newBirthday)
        })
    }
    componentDidUpdate(prevProps, prevState) {
        // 检查 showInfoFrom 是否发生变化
        if (prevState.showInfoFrom !== this.state.showInfoFrom) {
            const fill_in_page = document.querySelector('.fill_in_information_page')
            if (!this.state.showInfoFrom) {
                // 如果要隐藏，设置定时器
                fill_in_page.style.right = '-100%'
                setTimeout(() => {
                    fill_in_page.style.display = 'none'
                }, 500);
            } else {
                fill_in_page.style.display = 'block'
                setTimeout(() => {
                    fill_in_page.style.right = '0'
                }, 200);
            }
        }
    }

    searchChange = (e) => {
        this.setState({
            searchInputValue: e,
        })
        // 清除之前的定时器
        if (this.cityDebounceTimeout) {
            clearTimeout(this.cityDebounceTimeout);
        }
        this.cityDebounceTimeout = setTimeout(() => {
            if (e.trim().length >= 2) {
                this.getSearchResult(e);
                this.setState({
                    showSearchData: true,
                    cityLoading: true,
                })
            } else if (e.trim().length == 0) {
                this.setState({
                    showSearchData: false,
                })
            }
        }, 500);
    }
    changeCountry = (value) => {
        this.setState({
            country: value,
            isTab: '2',
            cityLoading: true,
        })
        this.getCity(value);
    }
    changeCity = (index) => {
        this.setState({
            city: this.state.cityData[index].city,
            lat: this.state.cityData[index].lat,
            long: this.state.cityData[index].long,
            isTab: '1',
            birthplacePop: false,
        })
    }
    changeSearchValue = (index) => {
        this.setState({
            country: this.state.searchData[index].country,
            city: this.state.searchData[index].city,
            lat: this.state.searchData[index].lat,
            long: this.state.searchData[index].long,
            showSearchData: false,
            isTab: '1',
            birthplacePop: false,
            searchInputValue: '',
        })
    }
    getCity = (value) => {
        axios({
            method: 'get',
            url: httpUrl + '/api/get_city',
            params: {
                country: value,
            }
        })
            .then(response => {
                this.setState({
                    cityList: response.data.data.map(item => item.city),
                    cityData: response.data.data,
                    cityLoading: false,
                },
                    () => {
                        // 滚动到顶部
                        if (this.cityListRef.current) {
                            this.cityListRef.current.scrollTo(0); // 调用 scrollTo 方法滚动到顶部
                        }
                    })
            })
            .catch(error => {
                console.error(error);
            });
    }
    getCountry = () => {
        axios({
            method: 'get',
            url: httpUrl + '/api/get_country',
        })
            .then(response => {
                this.setState({
                    countryList: response.data.data,
                })
            })
            .catch(error => {
                console.error(error);
            });
    }
    getSearchResult = (searchInputValue) => {
        axios({
            method: 'get',
            url: httpUrl + '/api/get_country_city_and_like',
            params: {
                content: searchInputValue,
            }
        })
            .then(response => {
                this.setState({
                    searchData: response.data.data,
                    cityLoading: false,
                },
                    () => {
                        // 滚动到顶部
                        if (this.searchListRef.current) {
                            this.searchListRef.current.scrollTo(0); // 调用 scrollTo 方法滚动到顶部
                        }
                    })
            })
            .catch(error => {
                console.error(error);
            });
    }
    whatsAppClick = () => {
        this.setState({
            isShowWhatsApp: true,
        });
    }
    hideWhatsAppDialog = () => {
        this.setState({
            isShowWhatsApp: false,
        });
    }
    startWhatsApp = () => {
        window.open("http://wa.me/886966427755",
            "_blank"
        )
    }
    cesuanType = (type) => {
        const cesuanType = localStorage.getItem("zodiacCesuanOption")
        if (!cesuanType) {
            this.sendMessage(type);
            localStorage.setItem("zodiacCesuanOption", type);
        } else {
            Toast.info("Single calculations only. Contact customer service for custom options.")
        }
    }
    //渲染组件
    render() {
        return (
            <>
                {this.state.isHelloView && (
                    <div style={{ display: 'flex', width: '100%', height: '100%', flexDirection: 'column' }}>
                        <HelloMessage messagelist={this.state.messageList} isHelloView={this.handleHelloViewChange} helloImage={this.state.helloImage} />
                        <PcGoodsMessage content={this.state.product} showProductDetail={this.showProductDetail} />
                    </div>
                )}
                <div className="main_chat" style={{ display: this.state.isHelloView ? 'none' : 'flex' }}>
                    <img src={zhanxingbackground} className="zhanxingbackground" />
                    <div className="chat">
                        <PageTitle title="Star sign" />
                        <div style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                            <HeadTitle avator={defaultImg}
                                botName={headTitleName}
                                roleClick={this.roleClick}
                                whatsAppClick={this.whatsAppClick} />
                            <MessageBox
                                messageList={this.state.messageList}
                                messagesContainerRef={this.messagesContainerRef}
                                chooseStar={this.chooseStar}
                                radioGender={this.radioGender}
                                radioBloodType={this.radioBloodType}
                                showCursor={this.state.showCursor}
                                isChatLoading={this.state.isChatLoading}
                                handleStarConfirm={this.handleStarConfirm}
                                handleBirthdayConfirm={this.handleBirthdayConfirm}
                                handleGenderConfirm={this.handleGenderConfirm}
                                showMore={this.showMore}
                                playAudio={this.playAudio}
                                stopAudio={this.stopAudio}
                                playAudioIndex={this.state.playAudioIndex}
                                showAudioLoading={this.state.showAudioLoading}
                                showProductDetail={this.showProductDetail}
                                confirmDiss={this.confirmDiss}
                                changeGoods={this.changeGoods}
                                showFillInInformation={this.showFillInInformation}
                                cesuanType={this.cesuanType}
                                whatsAppClick={this.startWhatsApp}
                            />
                        </div>
                        {
                            this.state.isBottomVisible && (
                                <div className="floating_button"
                                    onClick={this.scrollToBottom}>
                                    <img src={floatingBtn} />
                                </div>
                            )
                        }
                        <SendingBox sendMessage={this.sendMessage}
                            showSend={this.state.showSend}
                            inputFieldRef={this.inputFieldRef}
                            inputValue={this.state.inputValue}
                            sendBtnYesNo={this.sendBtnYesNo}
                            isShowYesNo={this.state.isShowYesNo}
                            isShowVoice={this.state.isShowVoice}
                            showVoiceView={this.showVoiceView}
                            hideVoiceView={this.hideVoiceView}
                            startRecording={this.startRecording}
                            stopRecording={this.stopRecording}
                            cancelRecording={this.cancelRecording}
                            volume={this.state.volume}
                            isRecording={this.state.isRecording}
                            onDataAvailable={this.onDataAvailable}
                            onVolumeValue={this.onVolumeValue}
                            onStop={this.onStop}
                            vadEnd={this.state.vadEnd}
                            popoverRef={this.popoverRef}
                            tipsList={this.state.tipsList}
                            // getTipsList={this.getTipsList}
                            isHelloView={this.state.isHelloView}
                            vadDelay={this.state.vadDelay}
                            ad_sid={this.state.ad_sid}
                        />
                        <Popup
                            visible={this.state.sendEmailVisible}
                            closeable
                            className="sendEmail"
                            position='center'
                            round
                            closeOnClickOverlay={false}
                            onClose={this.hideEmailPop}
                        >
                            <div className="sendEmail_box">
                                <span className="email_title">Fortune report</span>
                                <span className="email_content">Your fortune interpretation report is ready and will be sent to your email via email! 🔮</span>
                                <input
                                    className="email_input"
                                    type="email"
                                    value={this.state.email}
                                    onChange={this.handleEmailChange}
                                    placeholder={getSendEmail(current_locale)[1]}
                                />
                                <Button className="send_email_btn" style={{ width: '80%', height: '45px', marginTop: '25px', borderRadius: '10px' }} color='#B89054' type='primary' block disabled={this.state.isValidEmail} onClick={this.handleEmailSubmit}>
                                    {getSendEmail(current_locale)[0]}
                                </Button>
                            </div>
                        </Popup>
                        <Popup
                            visible={this.state.sendSuccessVisible}
                            closeable
                            className="sendEmail"
                            position='center'
                            round
                            closeOnClickOverlay={false}
                            onClose={this.hideSuccessPop}
                        >
                            <div className="sendEmail_box">
                                <span className="email_title">Success</span>
                                <span className="email_content">Your astrology report has been emailed. Check your inbox!</span>
                                <Button className="send_email_btn" style={{ width: '80%', height: '45px', marginTop: '25px', borderRadius: '10px' }} color='#B89054' type='primary' block onClick={this.hideSuccessPop}>
                                    Confirm
                                </Button>
                            </div>
                        </Popup>
                    </div>
                    <PcGoodsMessage content={this.state.product} showProductDetail={this.showProductDetail} />
                    <Popup
                        visible={this.state.isShowProduct}
                        closeable
                        style={{ height: '90%' }}
                        position='bottom'
                        round
                        onClose={() => this.setState({ isShowProduct: false })}
                    >
                        <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
                            <iframe src={this.state.iframeSrc} style={{ width: '100%', height: '100%', marginTop: '50px', border: 'none' }}></iframe>
                        </div>
                    </Popup>
                    <Picker
                        ref={this.roleRef}
                        popup={{
                            round: true,
                        }}
                        placeholder={picker_language[2]}
                        cancelButtonText={picker_language[1]}
                        confirmButtonText={picker_language[0]}
                        defaultValue={columns[3].value}
                        columns={columns}
                        onConfirm={this.handleRoleConfirm}
                    />
                    <Popup visible={this.state.isShowASR}
                        //closeable
                        style={{ height: '100%' }}
                        position='bottom'
                        onClose={() => { this.onCloseAsrPop() }} >
                        <Asr isRecording={this.state.isRecording}
                            onVolumeValue={this.state.volume}
                            startAsrRecord={this.startAsrRecord}
                            showAudioLoading={this.state.showAudioLoading}
                            onCloseAsrPop={this.onCloseAsrPop}
                        />
                    </Popup>
                    <Popup
                        visible={this.state.isShowWhatsApp}
                        className="whatsApp"
                        position='center'
                        round
                        closeOnClickOverlay={false}
                    >
                        <div className="whatsApp_box">
                            <img className="whatsApp_img" src={require('../../assets/update_new/whatsapp.png')} />
                            <span className="whatsApp_content">You're about to be redirected to a WhatsApp chat. Do you want to proceed?</span>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-around' }}>
                                <Button className="whatsApp_close" color='#9c7D7D7D' type='primary' block onClick={this.hideWhatsAppDialog}>
                                    Cancel
                                </Button>
                                <Button className="whatsApp_cofirm" color='#FFB341' type='primary' block onClick={this.startWhatsApp}>
                                    Confirm
                                </Button>
                            </div>
                        </div>
                    </Popup>
                </div >
                <div className="fill_in_information_page">
                    <img className="fill_in_back" src={arrow_left} onClick={() => this.setState({ showInfoFrom: false })}></img>
                    <div className="fill_in_div">
                        <span className="fill_in_title">Gender</span>
                        <Radio.Group className="radio_group" value={this.state.newGender} onChange={(e) => this.setState({ newGender: e })} direction="horizontal" checkedColor="rgba(184, 144, 84, 1)" iconSize="14px" >
                            <Radio className="radio" name="Male">Male</Radio>
                            <Radio className="radio" name="Female">Female</Radio>
                            <Radio className="radio" name="Other">Other</Radio>
                        </Radio.Group>
                    </div>
                    <div className="fill_in_div">
                        <span className="fill_in_title">Blood Type</span>
                        <Radio.Group className="radio_group" value={this.state.newBloodType} onChange={(e) => this.setState({ newBloodType: e })} direction="horizontal" checkedColor="rgba(184, 144, 84, 1)" iconSize="14px" >
                            <Radio className="radio" name="A">A</Radio>
                            <Radio className="radio" name="B">B</Radio>
                            <Radio className="radio" name="O">O</Radio>
                            <Radio className="radio" name="AB">AB</Radio>
                        </Radio.Group>
                    </div>
                    <div className="fill_in_div">
                        <span className="fill_in_title">Birthday</span>
                        <div className="fill_in_select" onClick={() => this.setState({ showBirthdayPicker: true })}>
                            <span style={{ color: this.state.newBirthdayShow ? 'white' : '' }}>{this.state.newBirthdayShow ? this.formatDateTime(this.state.newBirthday) : 'MM / DD / YYYY hh:mm:ss'}</span>
                            <img style={{ marginLeft: '10px' }} src={arrow_right}></img>
                        </div>
                    </div>
                    {/* <div className="fill_in_div">
                        <span className="fill_in_title">Star Sign</span>
                        <div className="fill_in_select" onClick={() => this.setState({ showStarPicker: true })}>
                            <span style={{ color: this.state.activeSign != '' ? 'white' : '' }}>{this.state.activeSign != '' ? this.state.activeSign : 'Please select'}</span>
                            <img style={{ marginLeft: '10px' }} src={arrow_right}></img>
                        </div>
                    </div> */}
                    <div className="fill_in_div">
                        <span className="fill_in_title">Birthplace</span>
                        <div className="fill_in_select" onClick={() => this.setState({ birthplacePop: true })}>
                            <span style={{ color: this.state.city ? 'white' : '' }}>{(this.state.country && this.state.city) ? this.state.city + " " + this.state.country : "Select your country and city"}</span>
                            <img style={{ marginLeft: '10px' }} src={arrow_right}></img>
                        </div>
                    </div>
                    <Popup
                        visible={this.state.birthplacePop}
                        closeable
                        className="birthplace"
                        position='bottom'
                        round
                        closeOnClickOverlay={true}
                        onClose={() => this.setState({ birthplacePop: false })}
                    >
                        <div className="birthplace_box">
                            <span className="birthplace_box_title">Birthplace</span>
                            <Input
                                placeholder="Search your country/region"
                                value={this.state.searchInputValue}
                                onChange={this.searchChange}
                                clearable
                                clearTrigger="always"
                            />
                            <div className="birthplace_tab" style={this.state.showSearchData ? { display: 'none' } : { display: 'flex' }}>
                                <span className={`birthplace_tab_text ${this.state.isTab == '1' ? 'active' : ''}`} onClick={() => this.setState({ isTab: '1' })}>{this.state.country ? this.state.country : 'Country'}</span>
                                {(this.state.isTab == '2' || this.state.cityData.length > 0) &&
                                    <>
                                        <span className='birthplace_tab_diver'></span>
                                        <span className={`birthplace_tab_text ${this.state.isTab == '2' ? 'active' : ''}`} onClick={() => this.setState({ isTab: '2' })}>{this.state.city ? this.state.city : 'City'}</span>
                                    </>
                                }
                            </div>
                            <div className="country_list" style={this.state.showSearchData ? { display: 'none' } : { display: 'flex' }}>
                                <div className="country_list_box_list" style={this.state.isTab == '1' ? { display: 'flex' } : { display: 'none' }}>
                                    <List
                                        height={500} // 可视区域高度
                                        itemCount={this.state.countryList.length} // 总数据条数
                                        itemSize={50} // 每行高度（需根据实际样式调整）
                                        width="90%" // 列表宽度
                                        style={{ scrollbarWidth: 'none' }}
                                    >
                                        {({ index, style }) => (
                                            <div key={index} style={style} className="country_list_box" onClick={() => this.changeCountry(this.state.countryList[index])}>
                                                <span className="country_list_text">{this.state.countryList[index]}</span>
                                                <img
                                                    style={{ width: '6px', height: '11px' }}
                                                    src={require('../../assets/activity/blackFive/icon_back_country_region.png')}
                                                />
                                            </div>
                                        )}
                                    </List>
                                </div>
                                <div className="city_list_box_list" style={this.state.isTab == '1' ? { display: 'none' } : { display: 'flex' }}>
                                    <List
                                        height={500} // 可视区域高度
                                        itemCount={this.state.cityList.length} // 总数据条数
                                        itemSize={50} // 每行高度（需根据实际样式调整）
                                        width="90%" // 列表宽度
                                        ref={this.cityListRef}
                                        style={this.state.cityLoading ? { display: 'none' } : { display: 'block', scrollbarWidth: 'none' }}
                                    >
                                        {({ index, style }) => (
                                            <div key={index} style={style} className="city_list_box" onClick={() => this.changeCity(index)}>
                                                <span className="city_list_text">{this.state.cityList[index]}</span>
                                                <img
                                                    style={{ width: '6px', height: '11px' }}
                                                    src={require('../../assets/activity/blackFive/icon_back_country_region.png')}
                                                />
                                            </div>
                                        )}
                                    </List>
                                    <div
                                        style={
                                            this.state.cityLoading
                                                ? { width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }
                                                : { display: 'none' }
                                        }
                                    >
                                        <Loading color="#EAA95A" />
                                    </div>
                                </div>
                            </div>
                            <div className="search_list" style={this.state.showSearchData ? { display: 'flex' } : { display: 'none' }}>
                                <div className="search_list_box_list">
                                    <List
                                        height={500} // 可视区域高度
                                        itemCount={this.state.searchData.length} // 总数据条数
                                        itemSize={50} // 每行高度（需根据实际样式调整）
                                        width="90%" // 列表宽度
                                        ref={this.searchListRef}
                                        style={this.state.cityLoading ? { display: 'none' } : { display: 'block', scrollbarWidth: 'none' }}
                                    >
                                        {({ index, style }) => (
                                            <div key={index} style={style} className="search_list_box" onClick={() => this.changeSearchValue(index)}>
                                                <span className="search_list_text">{this.state.searchData[index].city + " " + this.state.searchData[index].country}</span>
                                                <img
                                                    style={{ width: '6px', height: '11px' }}
                                                    src={require('../../assets/activity/blackFive/icon_back_country_region.png')}
                                                />
                                            </div>
                                        )}
                                    </List>
                                    <div
                                        style={
                                            this.state.cityLoading
                                                ? { width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }
                                                : { display: 'none' }
                                        }
                                    >
                                        <Loading color="#EAA95A" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Popup>

                    <div className="fill_in_tips_button">
                        <span style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px' }}><span style={{ color: 'rgba(184, 144, 84, 0.9)', fontSize: '16px', fontWeight: 'bold' }}>Tips:</span> Your privacy is protected in line with our policy, Please feel confident providing your information.</span>
                        <div className="fill_in_send_button" onClick={this.sendUserInfo}>
                            <img src={buttonSign}></img>
                            <span style={{ marginLeft: '5px' }}>Send</span>
                        </div>
                    </div>

                    <Popup
                        visible={this.state.showBirthdayPicker}
                        style={{ height: 'auto' }}
                        position='bottom'>
                        <div className="pop_birthday">
                            <div className="pop_birthday_top">
                                <span className="pop_birthday_title_text">Select Birthday</span>
                                <div>
                                    <DatetimePicker
                                        type='datetime'
                                        minDate={new Date(1900, 0, 1)}
                                        maxDate={new Date()}
                                        value={new Date(this.state.newBirthday)}
                                        onChange={(e) => this.setState({ newBirthday: e })}
                                    />
                                </div>
                                <div className="pop_birthday_confirm" onClick={this.confirmeBirthday}>
                                    <img src={buttonSignYellow}></img>
                                    <span style={{ marginLeft: '5px' }}>Confirm</span>
                                </div>
                            </div>
                            <div className="pop_birthday_canel" onClick={() => this.setState({ showBirthdayPicker: false })}>
                                <span>Cancel</span>
                            </div>
                        </div>
                    </Popup>

                    <Popup
                        visible={this.state.showStarPicker}
                        style={{ height: 'auto' }}
                        position='bottom'>
                        <div className="pop_star_sign">
                            <div className="pop_star_top">
                                <span className="pop_star_title_text">Select Zodiac Sign</span>
                                <img className="pop_star_close" src={starSignClose} onClick={() => this.setState({ showStarPicker: false })}></img>
                            </div>
                            <div className="pop_star_sign_list" >
                                <div className="zodiac-signs">
                                    {zodiacSigns.map((sign, index) => (
                                        <div style={{ display: 'flex' }} key={sign.name}>
                                            <div
                                                key={index}
                                                className={`sign ${this.state.activeSign === sign.name ? 'active' : ''}`}
                                                onClick={() => this.handleSignClick(sign.name)}
                                            >
                                                <img src={sign.image} alt={sign.name} />
                                                <span>{sign.name}</span>
                                            </div>
                                            <img className={`sign_selected ${this.state.activeSign === sign.name ? 'active' : ''}`} src={sign_selected} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="pop_star_sign_confirm" onClick={() => this.setState({ showStarPicker: false })}>
                                <img src={buttonSign}></img>
                                <span style={{ marginLeft: '5px' }}>Confirm</span>
                            </div>
                        </div>
                    </Popup>
                </div>
                <ConnectionLoading />
            </>
        );
    }
}
//消息体
class MessageBox extends React.Component {
    render() {
        const { messagesContainerRef, chooseStar, radioGender, radioBloodType, isChatLoading, handleStarConfirm, handleBirthdayConfirm, handleGenderConfirm, showMore, playAudio, stopAudio, playAudioIndex, showAudioLoading, showFillInInformation, cesuanType } = this.props;
        return (
            <div className="messageBox" ref={messagesContainerRef}>
                <Skeleton className="chat_skeleton" avatar loading={isChatLoading} ></Skeleton>
                {isChatLoading == false && (
                    this.props.messageList.map((messageData, index) => (
                        <div className="div_message_item" key={index}>
                            {messageData.isUser && messageData.type == 'string' && (
                                <UserMessage content={messageData.content}
                                />
                            )}
                            {messageData.isUser && messageData.type == 'info' && (
                                <UserMessageInfo newGender={messageData.newGender} newBirthday={messageData.newBirthday} newBloodType={messageData.newBloodType} newSign={messageData.newSign}
                                    showFillInInformation={showFillInInformation}
                                />
                            )}
                            {!messageData.isUser && (messageData.type == 'string' || messageData.type == 'hide') && (
                                <AiMessage
                                    length={this.props.messageList.length}
                                    index={index}
                                    avator={messageData.avator}
                                    botName={messageData.botName}
                                    content={messageData.content}
                                    category={messageData.category}
                                    radioGender={radioGender}
                                    radioBloodType={radioBloodType}
                                    chooseStar={chooseStar}
                                    showCursor={this.props.showCursor}
                                    locale={current_locale}
                                    handleStarConfirm={handleStarConfirm}
                                    handleBirthdayConfirm={handleBirthdayConfirm}
                                    handGenderConfirm={handleGenderConfirm}
                                    isShowDetail={messageData.isShowDetail}
                                    moreContent={messageData.moreContent}
                                    cesuan_hide_key={messageData.cesuan_hide_key}
                                    showMore={showMore}
                                    playAudio={playAudio}
                                    stopAudio={stopAudio}
                                    playAudioIndex={playAudioIndex}
                                    showAudioLoading={showAudioLoading}
                                    showFillInInformation={showFillInInformation}
                                    cesuanType={cesuanType}
                                />
                            )}
                            {!messageData.isUser && messageData.type == 'whatsApp' && (
                                <WhatsApp avator={messageData.avator} content={messageData.content}
                                    whatsAppClick={this.props.whatsAppClick} />
                            )}
                            {messageData.type == 'diss' && (
                                <DissMessage
                                    zan={messageData.zan}
                                    cai={messageData.cai}
                                    content={messageData.content}
                                    index={index}
                                    confirmDiss={this.props.confirmDiss}
                                    isShowChange={messageData.msg}
                                    changeGoods={this.props.changeGoods} />
                            )}
                            {!messageData.isUser && messageData.type == 'sku' && (
                                <GoodsMessage avator={messageData.avator}
                                    botName={messageData.botName}
                                    content={messageData.content}
                                    showProductDetail={this.props.showProductDetail}
                                    psychicId={psychic_id}
                                />
                            )}
                            {!messageData.isUser && messageData.type == 'star_pic' && (
                                <StarDiskMessage avator={messageData.avator}
                                    index={index}
                                    content={messageData.content}
                                    showMore={showMore}
                                />
                            )}
                            {!messageData.isUser && messageData.type == 'loading' && (
                                <LoadingMessage avator={messageData.avator}
                                    botName={messageData.botName}
                                    loading_text={messageData.loadingText} />
                            )}
                        </div>
                    ))
                )}
            </ div>
        );
    }
}
//底部input+item
class SendingBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputValue: props.inputValue,
            isComposing: false
        };
        this.debounceTimeout = null; // 定时器变量
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.inputValue !== this.props.inputValue) {
            this.setState({ inputValue: this.props.inputValue });
        }
        if (prevState.inputValue !== this.state.inputValue) {
            this.adjustTextareaHeight();
        }
    }
    adjustTextareaHeight() {
        const textarea = this.props.inputFieldRef.current;
        if (textarea) {
            textarea.style.height = 'auto'; // 重置高度以计算新的高度
            const scrollHeight = textarea.scrollHeight;
            const maxHeight = parseFloat(window.getComputedStyle(textarea).lineHeight) * 4; // 最大高度为4行
            textarea.style.height = `${Math.min(scrollHeight, maxHeight)}px`; // 动态调整高度
        }
    }
    handleInputChange = (event) => {
        this.setState({ inputValue: event.target.value });
        if (!this.props.isHelloView) {
            // 清除之前的定时器
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
            }
            const value = event.target.value;
            if (value && value.trim()) {
                // 设置新的定时器
                this.debounceTimeout = setTimeout(() => {
                    if (this.state.inputValue.trim()) {
                        // this.props.getTipsList(value, 'second_stage')
                        //this.props.popoverRef.current.show();
                    }
                }, 500);
            } else {
                this.props.popoverRef.current.hide();
            }
        }

    };

    //选择联想提示词
    handleSelectTips = (value) => {
        this.setState({ inputValue: value });
        this.props.popoverRef.current.hide();
    }

    //监听enter
    handleKeyDown = (event) => {
        if (event.key === 'Enter' && event.shiftKey) {
            // 如果按下的是 Shift + 回车，则执行换行操作
            return;
        }
        if (event.key === 'Enter' && !this.state.isComposing) {
            // 如果按下的是回车，并且没有在输入中文，则发送消息
            // 阻止默认的换行行为
            event.preventDefault();
            this.handleSendMessage();
        }
    }
    handleCompositionStart = () => {
        this.setState({ isComposing: true });
    };

    handleCompositionEnd = (e) => {
        this.setState({
            isComposing: false,
            inputValue: e.target.value
        });
    };

    handleSendMessage = () => {
        if (isFill_in) {
            const messages = document.getElementsByClassName('ai_content_message');
            if (messages.length > 0) {
                const lastMessage = messages[messages.length - 1];
                lastMessage.classList.add('animationInfoTips');
                // 可选：在动画结束后移除 `animated` 类
                setTimeout(() => {
                    lastMessage.classList.remove('animationInfoTips');
                }, 1200); // 动画持续时间
            }
            return; // 如果 isFill_in 为 true，则不执行发送消息的操作
        }
        const { sendMessage } = this.props;
        let message = this.state.inputValue;
        if ((this.state.inputValue.trim() !== "") && canSend) {
            sendMessage(message);
            this.setState({ inputValue: "" });
        }
    };
    render() {
        const { inputValue } = this.state;
        const { showSend, inputFieldRef, sendBtnYesNo, isShowYesNo, isShowVoice, showVoiceView, hideVoiceView, startRecording, stopRecording, cancelRecording, isRecording, onDataAvailable, volume, onStop, onVolumeValue, vadEnd, vadDelay } = this.props;
        // 判断 ad_sid 的值并设置对应的文本内容
        let labelText = 'Click to change your destiny!'; // 默认内容
        if (this.props.ad_sid) {
            if (this.props.ad_sid.charAt(0) == '1') {
                labelText = 'Unlock My Lucky Charm for Love';
            } else if (this.props.ad_sid.charAt(0) == '2') {
                labelText = 'Unlock My Lucky Charm for Wealth';
            }
        }
        return (
            <div className="sendingBox">
                {isShowVoice && (
                    <ColorChangeButton
                        stopRecording={stopRecording}
                        cancelRecording={cancelRecording}
                        startRecording={startRecording}
                        hideVoiceView={hideVoiceView}
                        vadEnd={vadEnd}
                        volume={volume} />
                )}
                <AudioRecorder
                    isRecording={isRecording}
                    onDataAvailable={onDataAvailable}
                    language_type={current_locale}
                    onStop={onStop}
                    onVolumeValue={onVolumeValue}
                    vadDelay={vadDelay} />
                {!isShowVoice && (
                    <Popover ref={this.props.popoverRef}
                        placement="top-start"
                        trigger="manual"
                        offset={[15, 10]}
                        reference={
                            <div className="bottom_border">
                                {isShowYesNo && (
                                    <div className="radio_option">
                                        <label className="radio-label_no" onClick={() => sendBtnYesNo('no')}>
                                            No
                                        </label>
                                        <label className="radio-label_yes" onClick={() => sendBtnYesNo('yes', labelText)}>
                                            {labelText}
                                        </label>
                                    </div>
                                )}
                                {!isShowYesNo && (
                                    <div className={`text_message_box ${inputValue.trim() !== '' ? 'foucs' : ''}`}>
                                        <textarea
                                            ref={inputFieldRef}
                                            className="text_message"
                                            value={inputValue}
                                            onChange={this.handleInputChange}
                                            placeholder={getOtherConfig(current_locale)[1]}
                                            onKeyDown={this.handleKeyDown} // 监听键盘事件
                                            onCompositionStart={this.handleCompositionStart}
                                            onCompositionEnd={this.handleCompositionEnd}
                                            rows={1} />
                                    </div>
                                )}
                                {!isShowYesNo && (
                                    <img
                                        className="voice_button"
                                        src={voice}
                                        onClick={showVoiceView}
                                    />
                                )}
                                {!isShowYesNo && (
                                    showSend ? (
                                        <img
                                            className={`send_button`}
                                            onClick={this.handleSendMessage}
                                            src={(inputValue.trim() !== '') ? sendBtnYes : sendBtnNo}
                                        />
                                    ) : (
                                        <div className="send_button_stop_box">
                                            <img
                                                className="send_button_loading"
                                                src={sendBtnIng}
                                            />
                                            <div style={{ width: '10px', height: '10px', backgroundColor: '#2c2c2c', borderRadius: '2px', position: 'absolute', display: 'none' }}></div>
                                        </div>
                                    )
                                )}
                            </div>
                        }>
                        <div className="tips_list">
                            {this.props.tipsList.map((item, index) => (
                                <div className="tips_item" key={index} onClick={() => this.handleSelectTips(item)}>
                                    {item}
                                </div>
                            ))}
                        </div>
                    </Popover>
                )}
            </div>
        );
    }
}